import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { ContentStorePropTypes } from "../../../utilities/propTypes";
import FeaturedContentShimmer from "../../shimmer/featuredContentShimmer";
import withShimmer from "../../shimmer/withShimmer";
import VideoCard from "./featuredVideoCard";

class FeaturedItemView extends Component {
  generateCards = () => {
    const {
      featuredItemStore: { data: contentItems }
    } = this.props;

    return (
      contentItems &&
      contentItems.map(item => <VideoCard key={item.id} video={item} />)
    );
  };

  render() {
    const { featuredItemStore } = this.props;
    return (
      <>
        <h2 className="text-center">Popular learning materials</h2>
        <div className="media-grid media-grid-bordered">
          <div className="row">
            {withShimmer(
              this.generateCards(),
              FeaturedContentShimmer,
              featuredItemStore.loadingStatus
            )}
          </div>
        </div>
      </>
    );
  }
}

FeaturedItemView.propTypes = {
  featuredItemStore: ContentStorePropTypes.isRequired
};

export default inject("featuredItemStore")(observer(FeaturedItemView));
